export enum BankAccountStatus {
  CLOSED = 'CLOSED',
  LOCKED = 'LOCKED',
  OPEN = 'OPEN',
  PENDING = 'PENDING',
  UNKNOWN = 'UNKNOWN',
}
